export enum ActionType {
  Click = 'Click',
  CloseModal = 'CloseModal',
}

export type ClickPayload = {
  isDepositNeeded: boolean
  isTransferNeeded: boolean
  isUnapproved: boolean
}

type ClickAction = {
  type: ActionType.Click
  payload: ClickPayload
}

type CloseModalAction = {
  type: ActionType.CloseModal;
}

export type Action = ClickAction | CloseModalAction;
